<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="群名" prop="chatName">
        <el-input
          v-model="queryParams.chatName"
          placeholder="请输入群名"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="群成员" prop="chatOwner">
        <el-input
            v-model="queryParams.chatOwner"
            placeholder="群成员名称"
            clearable
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

<!--    <el-row :gutter="10" class="mb8">-->
<!--      <el-col :span="1.5">-->
<!--        <el-button-->
<!--          type="primary"-->
<!--          plain-->
<!--          icon="el-icon-plus"-->
<!--          size="mini"-->
<!--          @click="handleAdd"-->
<!--          v-hasPermi="['wxCp:Chat:add']"-->
<!--        >新增</el-button>-->
<!--      </el-col>-->
<!--      <el-col :span="1.5">-->
<!--        <el-button-->
<!--          type="success"-->
<!--          plain-->
<!--          icon="el-icon-edit"-->
<!--          size="mini"-->
<!--          :disabled="single"-->
<!--          @click="handleUpdate"-->
<!--          v-hasPermi="['wxCp:Chat:edit']"-->
<!--        >修改</el-button>-->
<!--      </el-col>-->
<!--      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>-->
<!--    </el-row>-->

    <el-table v-loading="loading" :data="chatList" :default-sort="defaultSort" @sort-change="handleSortChange" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="客户群ID" align="center" prop="chatId" />
      <el-table-column label="群名" align="center" prop="chatName" />
      <el-table-column label="群主ID" align="center" prop="chatOwner" />
      <el-table-column label="创建时间" align="center" prop="chatCreateTime" width="180" sortable="custom" :sort-orders="['descending', 'ascending']">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.chatCreateTime, '{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="群公告" align="center" prop="chatNotice" />
<!--      <el-table-column label="创建时间" align="center" prop="createDate" width="180">-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{ parseTime(scope.row.createDate, '{y}-{m}-{d}') }}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column label="排序权重" align="center" prop="orderWeight" />-->
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="text"
              icon="el-icon-view"
              @click="handleLook(scope.row)"
              v-hasPermi="['wxCp:Chat:edit']"
          >查看成员</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />

    <!-- 添加或修改企业微信-外部群聊对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="1000px" append-to-body>
      <el-table :data="chatMemberList" >
<!--        <el-table-column label="成员id" align="center" prop="userid" />-->

        <el-table-column label="名字" align="center" prop="name" />
        <el-table-column label="成员类型" align="center" prop="type">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">企业员工</span>
            <span v-if="scope.row.type === 2">客户</span>
          </template>
        </el-table-column>
<!--        <el-table-column label="唯一标识" align="center" prop="unionid" width="180"/>-->
        <el-table-column label="入群时间" align="center" prop="joinTime" width="180">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.joinTime, '{y}-{m}-{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center" prop="groupNickname" />
        <el-table-column label="入群方式" align="center" prop="joinScene">
          <template slot-scope="scope">
            <span v-if="scope.row.joinScene === 1">直接邀请</span>
            <span v-if="scope.row.joinScene === 2">邀请链接</span>
            <span v-if="scope.row.joinScene === 2">扫描群</span>
          </template>
        </el-table-column>
        <el-table-column label="邀请者" align="center" prop="invitorUserid" />

      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  import {addChat, delChat, getChat, listChat, updateChat} from "@/api/wxCp/Chat";
  import {listChatMember} from "@/api/wxCp/ChatMember";

  export default {
  name: "Chat",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 企业微信-外部群聊表格数据
      chatList: [],
      chatMemberList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        chatName: null,
        chatOwner: null,
        chatCreateTime: null,
        chatNotice: null,
        createDate: null,
        orderWeight: null
      },
      // 默认排序
      defaultSort: {prop: 'chatCreateTime', order: 'descending'},
      // 表单参数
      form: {},
      // 表单校验
      rules: {
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询企业微信-外部群聊列表 */
    getList() {
      this.loading = true;
      listChat(this.queryParams).then(response => {
        this.chatList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        chatId: null,
        chatName: null,
        chatOwner: null,
        chatCreateTime: null,
        chatNotice: null,
        createDate: null,
        orderWeight: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.chatId)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 排序触发事件 */
    handleSortChange(column, prop, order) {
      this.queryParams.orderByColumn = column.prop;
      this.queryParams.isAsc = column.order;
      this.getList();
    },
    handleLook(row) {
      const chatId = row.chatId || this.ids
      listChatMember({chatId: chatId}).then(response => {
        this.chatMemberList = response.rows;
        this.open = true;
        this.title = "群聊成员";
      });
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加企业微信-外部群聊";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const chatId = row.chatId || this.ids
      getChat(chatId).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改企业微信-外部群聊";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.chatId != null) {
            updateChat(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addChat(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const chatIds = row.chatId || this.ids;
      this.$modal.confirm('是否确认删除企业微信-外部群聊编号为"' + chatIds + '"的数据项？').then(function() {
        return delChat(chatIds);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('wxCp/chat/export', {
        ...this.queryParams
      }, `chat_${new Date().getTime()}.xlsx`)
    }
  }
};
</script>
